import { IEntity } from '@pf/shared-common';
import {
    PickFragment,
    PickListSearchRequestParams,
    PickListViewModelCreateBody,
    PickListViewModelRead,
    ResourceAuth,
    WarehouseFragment,
} from '@control-tower/platform-wms';
import { IWarehouseEntity } from '../interfaces/warehouse-entity';

export type PickListRead = PickListViewModelRead & IEntity;
export type PickListCreate = PickListViewModelCreateBody;
export type PickListSearchParams = PickListSearchRequestParams;

export class PickListDto implements IWarehouseEntity {
    constructor(data: Partial<PickListDto>) {
        Object.assign(this, data);
    }
    id!: string;
    warehouse!: WarehouseFragment;

    assignedTo?: string | null;
    pickByDate?: string;
    organizedBy?: string | null;
    status?: string | null;
    picks?: PickFragment[];
    warehouseId?: string;

    get name(): string {
        return `${this.status} - ${this.pickByDate}`;
    }

    resourceAuth?: ResourceAuth;
    createdDate?: string;
    modifiedDate?: string;
    isDeleted?: boolean;
}
